import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';

interface UserManagementState {
  usersListFinding: string;
  userEditId: string | null;
}

const initialState: UserManagementState = {
  usersListFinding: '',
  userEditId: null,
};

const userManagementSlice = createSlice({
  name: 'userManagement',
  initialState: initialState,
  reducers: {
    setUsersFinding: (state, action: PayloadAction<string>) => {
      state.usersListFinding = action.payload;
    },
    setUserEditId: (state, action: PayloadAction<string | null>) => {
      state.userEditId = action.payload;
    },
  },
});

export const { setUsersFinding, setUserEditId } = userManagementSlice.actions;

export const selectUsersFinding = (state: RootState) => {
  return state.userManagement.usersListFinding;
};
export const selectUserEditId = (state: RootState) => {
  return state.userManagement.userEditId;
};

export const userManagementReducer = userManagementSlice.reducer;
